export const isEmpty = <T>(
  value: T,
): value is T & (null | undefined | "" | [] | Record<string, never>) => {
  if (value === undefined || value === null) return true;
  if (typeof value === "string" && value.trim() === "") return true;
  if (typeof value === "object" && Object.keys(value).length === 0) return true;
  return Array.isArray(value) && value.length === 0;
};

export const isNotEmpty = <T>(value: T): value is NonNullable<T> => {
  return !isEmpty(value);
};
